import storage from 'redux-persist/lib/storage';

export const WAITER_PERSIST_KEY = 'persist:root-waiter';

const parseJsonObject = (value) => {
  if (typeof value !== 'string') {
    return null;
  }

  try {
    return JSON.parse(value);
  } catch (error) {
    return null;
  }
};

const getDefaultStorageArea = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  return window.localStorage;
};

export const getPersistedAuthenticationState = (serializedState) => {
  const persistedState = parseJsonObject(serializedState);
  return parseJsonObject(persistedState?.authentication);
};

export const hasAuthenticationData = (authenticationState) => Boolean(
  authenticationState?.loggedIn
  || authenticationState?.accessToken
  || authenticationState?.refreshToken,
);

const hasExistingPersistedState = (key, storageArea) => {
  if (!storageArea?.getItem) {
    return false;
  }

  try {
    return storageArea.getItem(key) != null;
  } catch (error) {
    return false;
  }
};

export const shouldSkipUnauthenticatedPersistWrite = (
  key,
  value,
  storageArea = getDefaultStorageArea(),
) => {
  if (key !== WAITER_PERSIST_KEY || hasExistingPersistedState(key, storageArea)) {
    return false;
  }

  const authenticationState = getPersistedAuthenticationState(value);
  return authenticationState != null && !hasAuthenticationData(authenticationState);
};

export const waiterPersistStorage = {
  ...storage,
  setItem: (key, value) => {
    if (shouldSkipUnauthenticatedPersistWrite(key, value)) {
      return Promise.resolve();
    }

    return storage.setItem(key, value);
  },
};
